import { render, staticRenderFns } from "./freightOrderCreate.vue?vue&type=template&id=262a53f6&scoped=true"
import script from "./freightOrderCreate.vue?vue&type=script&lang=js"
export * from "./freightOrderCreate.vue?vue&type=script&lang=js"
import style0 from "./freightOrderCreate.vue?vue&type=style&index=0&id=262a53f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262a53f6",
  null
  
)

export default component.exports